'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = modelToReducer;

var _seamlessImmutable = require('seamless-immutable');

var _seamlessImmutable2 = _interopRequireDefault(_seamlessImmutable);

var _stateObserver = require('./stateObserver');

var _stateObserver2 = _interopRequireDefault(_stateObserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// # 数据模型转Reducer
function modelToReducer(model, initialState, isImmutable) {
  return function modelReducer() {
    var store = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var reducer = model._reducers[action.type];
    var nextStore = store;
    if (reducer) {
      var prevStore = new _stateObserver2.default(store, model.state, function () {
        model.__setIncrement();
      });
      /**
       * ### 每个action的副作用的执行
       *
       * | 参数 | 参数类型
       * |: ------ |: ------ |
       * | prevStore | 当前可变的model数据 |
       * | paylaod | 数据装载对象，当前action函数执行的结果值会存到data中 |
       *
       * 这种方式其实并不友好，因为结果没法预测，redux中的要点是可预测结果的state。
       *
       * 而目前store直接交给副作用来填充，返回结果不可预测。也没有做校验，建议后期加上结构变更的校验。
       */
      nextStore = reducer.call(model, prevStore, action.payload);
      // 当有返回值时，用返回值作为新的state, 否则使用prevStore对象。
      if (nextStore === undefined || nextStore instanceof _stateObserver2.default) {
        nextStore = prevStore.getStore();
      } else {
        model.state = nextStore.asMutable ? nextStore.asMutable({ deep: true }) : nextStore;
      }
      return isImmutable ? (0, _seamlessImmutable2.default)(nextStore) : nextStore;
    } else {
      return nextStore;
    }
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/seed/modelToReducer.js
// module id = 152
// module chunks = 0